<template>
  <!--
    Reusable Kazang 2FA OTP prompt. NOT a render-on-mount component — call
    `DepositOtpPrompt.show({ phoneHint, expiresAt, userRequestId })` from any view
    to open a SweetAlert2 modal and receive a Promise<{ otp }>.

    This component exists so the show() helper has a Vue home (easy to discover in
    the components folder) and so we can extend later (e.g. countdown timer) without
    touching every call site.

    See docs/gap_analysis_petty_cash_otp_modal.md for full context.
  -->
  <div aria-hidden="true"></div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  name: 'DepositOtpPrompt',
  methods: {
    /**
     * Open the OTP prompt.
     *
     * @param {Object} opts
     * @param {string} opts.phoneHint - merchant WhatsApp hint, e.g. "+26097****5308"
     * @param {string} opts.expiresAt - ISO datetime from Phase 1 response
     * @param {number} opts.userRequestId - for the confirm-otp call (passed through to caller)
     * @returns {Promise<{ otp: string, userRequestId: number }>}
     *          resolves on submit; rejects with Error('cancelled') on cancel/close.
     */
    show(opts) {
      const expires = new Date(opts.expiresAt);
      const expiresLabel = isNaN(expires.getTime())
        ? opts.expiresAt
        : expires.toLocaleTimeString();
      return Swal.fire({
        title: 'Enter OTP',
        html: `
          <p class="mb-2">Kazang sent a 6-digit code to merchant WhatsApp:</p>
          <p class="mb-2"><strong>${opts.phoneHint || '(unknown number)'}</strong></p>
          <p class="text-muted small mb-3">Code expires at ${expiresLabel}</p>
          <input id="deposit-otp-input"
                 class="swal2-input"
                 maxlength="6"
                 pattern="\\d{6}"
                 inputmode="numeric"
                 autocomplete="one-time-code"
                 placeholder="123456" />
        `,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showLoaderOnConfirm: !Swal.isLoading(),
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: () => {
          const input = document.getElementById('deposit-otp-input');
          const otp = input ? input.value.trim() : '';
          if (!/^\d{6}$/.test(otp)) {
            Swal.showValidationMessage('Enter the 6-digit code from WhatsApp');
            return false;
          }
          return otp;
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return { otp: result.value, userRequestId: opts.userRequestId };
        }
        throw new Error('cancelled');
      });
    },
  },
};
</script>